// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { z } from 'zod';
export const deviceModelId = (z.number());
export const deviceModel = z.object({
    id: deviceModelId,
    unit: z.string(),
    name: z.string().nullable(),
    firmware_version: z.string().nullable(),
    manifest_raw: z.unknown().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const deviceModelInitializer = z.object({
    id: deviceModelId.optional(),
    unit: z.string(),
    name: z.string().optional().nullable(),
    firmware_version: z.string().optional().nullable(),
    manifest_raw: z.unknown().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const deviceModelMutator = z.object({
    id: deviceModelId.optional(),
    unit: z.string().optional(),
    name: z.string().optional().nullable(),
    firmware_version: z.string().optional().nullable(),
    manifest_raw: z.unknown().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=DeviceModel.js.map